export default {
  configuration_preview_title: "Configuration Preview",
  configuration_preview_success_message: "Configuration saved successfully",
  configuration_preview_error_message: "The configuration could not be saved",
  configuration_preview_save_changes: "Save Changes",
  
}
